<script>
  export let data;
</script>

<style></style>

<div class="fc sy-xs">
  <h6>{data.header}</h6>
  <p class="p4">{data.text}</p>
</div>

